var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "relation-class",
    attrs: {
      visible: _vm.relationModelVisible,
      footer: null,
      width: 500
    },
    on: {
      cancel: _vm.closeRelation
    }
  }, [_c("div", {
    staticClass: "relation-model"
  }, [_c("div", {
    staticClass: "relation-title"
  }, [_c("span", {
    staticClass: "relation-span"
  }, [_vm._v(_vm._s(_vm.$t("当前控件")) + "：")]), _c("span", [_vm._v(_vm._s(_vm.formDataArray[_vm.relationModelIndex] && _vm.formDataArray[_vm.relationModelIndex].controlName))])]), _c("div", {
    staticClass: "relation-control"
  }, [_c("span", {
    staticClass: "relation-span"
  }, [_vm._v(_vm._s(_vm.$t("关联控件")) + "：")]), _c("a-select", {
    staticClass: "select-class",
    on: {
      change: _vm.changeRelation
    },
    model: {
      value: _vm.selectValue,
      callback: function ($$v) {
        _vm.selectValue = $$v;
      },
      expression: "selectValue"
    }
  }, _vm._l(_vm.conformData, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.mark
      }
    }, [_vm._v(" " + _vm._s(item.controlName) + " ")]);
  }), 1)], 1), !_vm.isEmptyObject(_vm.selectData) ? _c("div", {
    staticClass: "relation-content"
  }, [_c("span", {
    staticClass: "relation-span"
  }, [_vm._v(_vm._s(_vm.$t("当0选择下面的").replace("0", _vm.selectData.controlName)) + "：")]), ["singleChoice", "multipleChoice"].indexOf(_vm.selectData.partsType) !== -1 ? _c("a-checkbox-group", {
    staticStyle: {
      height: "200px",
      "overflow-y": "auto"
    },
    model: {
      value: _vm.checkedData,
      callback: function ($$v) {
        _vm.checkedData = $$v;
      },
      expression: "checkedData"
    }
  }, _vm._l(_vm.selectData.controlValue, function (item, index) {
    return _c("a-checkbox", {
      key: index,
      staticClass: "relation-checkbox",
      attrs: {
        value: item.name,
        label: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " " + _vm._s(item.checked) + " ")]);
  }), 1) : _vm._e(), ["dropDown"].indexOf(_vm.selectData.partsType) !== -1 ? _c("a-checkbox-group", {
    staticStyle: {
      height: "200px",
      "overflow-y": "auto"
    },
    model: {
      value: _vm.checkedData,
      callback: function ($$v) {
        _vm.checkedData = $$v;
      },
      expression: "checkedData"
    }
  }, _vm._l(_vm.selectOptions, function (item, index) {
    return _c("a-checkbox", {
      key: index,
      staticClass: "relation-checkbox",
      attrs: {
        value: item.value,
        label: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1) : _vm._e(), _c("span", {
    staticClass: "relation-span"
  }, [_vm._v(_vm._s(_vm.$t("任一选项时，当前控件才会出现")))])], 1) : _vm._e(), !_vm.isEmptyObject(_vm.selectData) ? _c("div", {
    staticClass: "relation-footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.confirmRelation
    }
  }, [_vm._v(_vm._s(_vm.$t("确定")))])], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };